
// Form floating labels
function floatingLabels() {

  // if ( $('.form-field.floating-label input, .form-field.floating-label select, .form-field.floating-label textarea').data('ui-autocomplete') != undefined ) {
  //   console.log('if');
  //   //$(this).parent('.form-field').addClass('open');
  // }
  // else {
  //   console.log('else');
  //   //$(this).parent('.form-field').addClass('open');
  // }

  // On load
  // $( document ).ready(function() {
  //   console.log('doc ready');
    //setTimeout( function() {
      //console.log('timeout done');
      $('.form-field.floating-label input, .form-field.floating-label select, .form-field.floating-label textarea').each( function(i) {

        // if (i == 0) {
        //   $(this).focus();
        // }

        //$(this).css('opacity', '0.5');
        //$(this).blur();
    		if ($(this).val() != '') {
    			$(this).parent('.form-field').addClass('open'); // Activate if field has content
    		}
    	});
    //}, 3000);
  //});

  // On focus-on
	$('.form-field.floating-label input, .form-field.floating-label select, .form-field.floating-label textarea').focus( function() {
		// Check other inputs
		$(this).parent('.form-field').siblings('.form-field.floating-label').each( function() {
			if ($(this).children('input').val() == "") {
				$(this).removeClass('open'); // Reset label if input is empty
			}
		});
		// Minify current
		$(this).parent('.form-field').addClass('open');
	});
	// On focus-off
	$('.form-field.floating-label input, .form-field.floating-label select, .form-field.floating-label textarea').blur( function() {
		if (!$(this).val()) {
			$(this).parent('.form-field').removeClass('open'); // Reset label if input is empty
		} else {
      $(this).parent('.form-field').addClass('open');
    }
	});//.blur(); // call blur initially

  //$(document).click();

  //$('.form-field.floating-label input').blur();
}
$( document ).ready(function() {
  //setTimeout( function() {
    floatingLabels();
    // setTimeout( function() {
    //   floatingLabels();
    // },4000);
    //$('.form-field.floating-label input').blur();
  //}, 200);
});
